export default __webpack_public_path__ + "static/media/Survivor_1_SVG.007ee41c.svg";